import { supportServiceConnectClient } from "api";

import {
  GetOrgPreferencesRequest,
  GetOrgPreferencesResponse,
  GetUserNotificationSettingsRequest,
  GetUserNotificationSettingsResponse,
} from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

import { RequestMetadata } from "api/types";

type GetUserNotificationSettingsParams = {
  userId: string;
  orgId: string;
};

export const getUserNotificationSettings = async (
  { userId, orgId }: GetUserNotificationSettingsParams,
  headers: Record<RequestMetadata, string>
): Promise<GetUserNotificationSettingsResponse> => {
  const req = new GetUserNotificationSettingsRequest({ userId, orgId });

  return supportServiceConnectClient.getUserNotificationSettings(req, {
    headers,
  });
};

type GetOrgPreferencesParams = {
  orgId: string;
};

export const getOrgPreferences = async (
  { orgId }: GetOrgPreferencesParams,
  headers: Record<RequestMetadata, string>
): Promise<GetOrgPreferencesResponse> => {
  const req = new GetOrgPreferencesRequest({ orgId });

  return supportServiceConnectClient.getOrgPreferences(req, { headers });
};
